/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const MessageSmileRegularV6 = (props) => (
  <Icon {...props} name="Message Smile Regular V6">
    <path d="M13.972 0h-12c-1.102 0-2 .898-2 1.972v8.972c0 1.102.898 1.972 2 1.972h3v2.625c0 .307.344.486.598.303l3.903-2.928h4.5c1.102 0 2-.898 2-1.972V1.972A1.983 1.983 0 0 0 13.972 0zm.528 11c0 .273-.227.5-.5.5H9l-2.5 1.875V11.5H2a.504.504 0 0 1-.5-.5V2c0-.273.227-.5.5-.5h12c.273 0 .5.227.5.5v9zM10 5.472c.555 0 1-.445 1-.972s-.445-1-.972-1c-.527 0-.972.445-.972 1s.391.972.944.972zm-4 0c.555 0 1-.445 1-.972s-.445-1-.972-1c-.527 0-.972.445-.972 1s.391.972.944.972zm4.181 2.037A2.866 2.866 0 0 1 8 8.5a2.86 2.86 0 0 1-2.179-.992.752.752 0 0 0-1.058-.086.75.75 0 0 0-.081 1.056c.828.969 2.034 1.523 3.319 1.523s2.493-.554 3.322-1.523a.75.75 0 0 0-1.141-.969z" />
  </Icon>
);

export default MessageSmileRegularV6;
